<template>
  <v-app :dark="isDark">
      <v-navigation-drawer
      fixed
      temporary
      :clipped="$vuetify.breakpoint.mdAndUp"
      app
      v-model="drawer"
    >
      <v-list dense>
        <template v-for="item in items">
          <v-layout
            row
            v-if="item.heading"
            align-center
            :key="item.heading"
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            v-show="item.children.length>0"
            v-model="item.model"
            :key="item.text"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
              @click="jumpToLink(child.to)"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else-if="item.href" @click="openInternalHref(item.href)" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-else @click="jumpToLink(item.to)" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      color="primary darken-1 hidden-print-only"
      v-if="!hideToolbar"
      dark
      dense
      app
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      fixed
    >
      <v-toolbar-title v-if="!disableMenu" :style="brandName=='JEC' ? 'width: 80px' :'width: 600px'" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span v-if="brandName!='JEC'" class="hidden-sm-and-down">{{brandName}} - {{facilityName}} </span>
      </v-toolbar-title>
      <img v-if="brandName=='JEC'" @click="jumpToLink('/overview')" class="cursor-as-pointer" :src="require('@/assets/img/logojec.jpg')" height="48"/>
      <span v-if="brandName=='JEC'" @click="jumpToLink('/overview')" class="hidden-sm-and-down cursor-as-pointer" style="padding-top: 28px;">
            - {{facilityName}}
        </span>
      <v-spacer></v-spacer>
      <v-btn icon to="/overview">
        <v-icon>fa-th</v-icon>
      </v-btn>
      <v-badge v-if="!disableNotifications"
          color="accent"
          overlap
        >
          <template v-slot:badge>
            <span>{{notificationCount}}</span>
          </template>
        <v-icon @click="jumpToLink('/notifications')" >fa-bell</v-icon>
        </v-badge>
      <v-btn v-if="!disableNotifications" icon to="/maintenancerecord">
        <v-icon>fa-notes-medical</v-icon>
      </v-btn>
      <v-menu offset-y>
        <v-btn icon large slot="activator">
          <v-avatar size="32px" tile>
            <v-icon>fa-user</v-icon>
          </v-avatar>
        </v-btn>

        <v-list>
          <v-list-tile><v-list-tile-title>Logged in as {{username}}</v-list-tile-title></v-list-tile>
          <v-list-tile @click.prevent="logout">
            <v-list-tile-title> Logout </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-content>
      <transition enter-active-class="animated fadeIn"
                  leave-active-class="animated flipOutY"
                  appear
                  mode="out-in">
      <v-container key="1" fluid fill-height v-if="$store.state.pointsListStore.pointsLoaded||forceDisplay">
        <v-layout justify-center align-start>
          <transition name="slide-fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-layout>
      </v-container>
      <v-container key="2" fluid fill-height v-else>
        <v-layout justify-center align-center>
          Loading Points List <v-progress-circular class="ml-3" color="primary" indeterminate></v-progress-circular>
        </v-layout>
      </v-container>
      </transition>


    </v-content>
    <v-toolbar v-if="hideToolbar">
      <v-btn outline class="secondary" to="/notifications">Notification</v-btn>
      <v-btn outline class="secondary" to="/modelsummary">Machine Learning Fault Detection</v-btn>
      <v-btn outline class="secondary" to="/controllogic">Control Logic Benefit</v-btn>
      <v-btn outline class="secondary" to="/multiplots">Time Series Plot</v-btn>
      <v-btn outline class="secondary" to="/maintenancerecord">Maintenance Record</v-btn>
      <v-btn outline class="secondary" to="/energyefficiency">COP</v-btn>
      <v-btn outline class="secondary" to="/load">Cooling Load</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat @click="drawer=!drawer">   </v-btn>
    </v-toolbar>

    <global-snackbar></global-snackbar>

  </v-app>
</template>


<script>

import GlobalSnackbar from './components/GlobalSnackbar'
import { jwtDecode} from './helper'
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  components: { GlobalSnackbar },
  data: () => ({
    openfault: true,
    forceDisplay:false,
      dialog: false,
      drawer: false,

    }),
    props: {
    },
  methods: {
    jumpToLink (payload) {
      this.$router.push(payload)
    },
    openInternalHref(href){
      let pass = localStorage.getItem('pass');
      window.location.href=href+'?token='+pass;
    },
    logout () {
      localStorage.setItem('pass', '') //reset token in localstorage
      window.location.href="/login";
    }
  },
  watch: {
    '$route.name': {
      handler: function(item) {
        if(item==="login"){
          this.forceDisplay=true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters([
      'automatedViewsConfig','userPlots',
    ]),
    brandName(){
      return process.env.VUE_APP_BRAND_NAME ? process.env.VUE_APP_BRAND_NAME : "Carnot Innovations"
    },
    disableMenu(){
      return process.env.VUE_APP_DISABLE_MENU ? process.env.VUE_APP_DISABLE_MENU : false
    },
    disableNotifications(){
      return process.env.VUE_APP_DISABLE_NOTIFICATIONS ? process.env.VUE_APP_DISABLE_NOTIFICATIONS : false
    },
    isDark(){
      return process.env.VUE_APP_THEME=='dark'
    },
    facilityName(){
      return this.$store.state.pointsListStore.pointsList.facility_name;
    },
    hideToolbar () {
      return process.env.VUE_APP_HIDE_TOOLBAR=='yes'
    },
    username () {
      if (this.$store.state.userStore.user) {
        return this.$store.state.userStore.user.content.user_name
      }
      return null;
    },
    notificationCount () {
      return this.$store.getters.recentNotificationsCount
    },
    items () {
      return _.filter(this.rawItems, (x) => {
        return !(_.get(x, 'disabled', false))
      })
    },
    rawItems () {
      let allItems=[]
      if(process.env.VUE_APP_MENU_CONFIG&&process.env.VUE_APP_MENU_CONFIG!==""){
        allItems=require('./config/menu/'+process.env.VUE_APP_MENU_CONFIG+".js").default()
      } else {
        allItems = [
          {icon: 'fa-address-book', text: 'Overview', to: '/overview'},
          {icon: 'fa-bolt', text: 'Energy', to: '/hkl-energy', disabled: this.facilityName !== 'ES'}, //no point in showing since ES overview is literally this
          {icon: 'fa-chart-bar', text: 'KPI', to: '/hkl-kpi', disabled: this.facilityName !== 'ES'},
          {
            icon: 'fa-bell',
            text: 'Notification Breakdown',
            to: '/notification-breakdown',
            disabled: this.facilityName !== 'ES'
          },
          {
            icon: 'fa-calendar-alt',
            text: 'Monthly Summary',
            to: '/monthly-summary',
            disabled: this.facilityName != 'ES'
          },
          {
            icon: 'fa-chart-bar',
            text: 'Detailed Overview',
            to: '/detailed-overview',
            disabled: this.facilityName != 'SHT' && this.facilityName != 'CRP'
          },
          {
            icon: 'fa-piggy-bank',
            text: 'Key Savings Metrics',
            to: '/key-savings',
            disabled: this.facilityName != 'SHT'
          },

          {
            icon: 'fa-chart-bar',
            text: 'KPI',
            to: '/kpi-view',
            disabled: this.facilityName != 'SHT' && this.facilityName != 'CRP'
          },
          {icon: 'fa-bolt', text: 'Power Consumption', to: '/power-consumption', disabled: this.facilityName != 'SHT'},
          {
            icon: 'fa-bolt',
            text: 'Energy Consumption trend',
            to: '/energy-trend',
            disabled: this.facilityName == 'ES' || this.facilityName == 'AZBIL'
          }, //no point in showing since ES overview is literally this
          {icon: 'fa-chart-pie', text: 'Circuits', to: '/circuits', disabled: this.facilityName != 'SHT'},
          {icon: 'fa-thermometer-half', text: 'Graphical', to: '/graphical', disabled: this.facilityName != 'CRP'},
          {icon: 'fa-history', text: 'Cooling Load', to: '/load', disabled: this.facilityName == 'AZBIL'},

          {
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'Plots',
            model: false,
            children: [
              {icon: 'fa-chart-bar', text: 'Simple Plots', to: '/sensors'},
              {icon: 'fa-chart-line', text: 'Time Series Plots', to: '/multiplots'},
              {icon: 'fa-chart-line', text: 'Equipment Plots', to: '/equipment-plots'},
              {icon: 'fa-layer-group', text: 'Facet Plots', to: '/plot/facet'},
            ]
          },


          {icon: 'fa-bell', text: 'Fault Detection', to: '/fault'},
          {icon: 'fa-bell', text: 'Fault Detection (Machine Learning)', to: '/modelsummary'},


          {
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'Diagnostics',
            model: false,
            disabled: this.$store.getters.chillerType != 'generic water-cooled' && this.facilityName != 'SHT' || this.facilityName == 'AZBIL',
            children: this.facilityName == 'SHT' ? [
              {text: 'Number of Observations', to: '/observations'},
            ] : this.facilityName == 'ES' ? [{text: 'Cooling Load VS Outdoor Temperature', to: '/cl-vs-oat'},
              {text: 'Chiller Sequencing Profile - % of FLA', to: '/chiller-sequencing-fla'},
              {text: 'Chiller Sequencing Profile - DTchw', to: '/chiller-sequencing-delta'}] : []
          },
          {
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'Control Logic',
            model: false,
            disabled: this.facilityName == 'ES' || this.facilityName == 'AZBIL',
            children: [
              {icon: 'fa-bolt', text: 'Energy Efficiency', to: '/energyefficiency'},
              {icon: 'fa-calculator', text: 'COP Calculator', to: '/refrigerantcalculate'},
              {icon: 'fa-thermometer-half', text: 'Control Logic Benefit', to: '/controllogic'},
              {icon: 'fa-magic', text: 'Dynamic Control Output', to: '/controloutput'},
            ]
          },
          {
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'Control Logic',
            model: false,
            disabled: this.facilityName != 'ES',
            children: [
              {icon: 'fa-bolt', text: 'Energy Efficiency', to: '/energyefficiency'},
              // { icon: 'fa-calculator', text: 'COP Calculator', to: '/refrigerantcalculate'},
              // { icon: 'fa-thermometer-half', text: 'Control Logic Benefit', to:'/controllogic' },
            ]
          },
          {
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'Config',
            model: false,
            children: [
              {icon: 'fa-tools', text: 'Equipments', to: '/equipments'},
              {icon: 'fa-building', text: 'Facilities', to: '/facility'},
              {icon: 'fa-bell', text: 'Anomaly Descriptions', to: '/anomaly-description'},
              {icon: 'fa-broadcast-tower', text: 'Points', to: '/points'},
              {icon: 'fa-cog', text: 'Config', to: '/config'},
              {icon: 'fa-ruler-horizontal', text: 'Parameter', to: '/parameter'},
              {icon: 'fa-chart-line', text: 'KPI', to: '/KPI'},
              {icon: 'fa-sliders-h', text: 'Settings', to: '/settings'},
              {icon: 'fa-mail-bulk', text: 'Report', to: '/report'},
              {icon: 'fa-align-justify', text: 'Rules', to: '/rules'},
              {icon: 'fa-users', text: 'Users', to: '/users'},
              {icon: 'fa-download', text: 'Export Data', to: '/viewdata'}
            ]
          },

          {icon: 'fa-notes-medical', text: 'Maintenance Record', to: '/maintenancerecord'},
          {icon: 'fa-question', text: 'Help', to: '/help'}
        ];
      }
      for(let id in this.automatedViewsConfig){
        let itemEntry={
          icon: this.automatedViewsConfig[id].icon,
          text: this.automatedViewsConfig[id].linkTitle,
          to:'/automated/'+id
        };
        if(this.automatedViewsConfig[id].menu){
          let found=false;
          for (let item of allItems){
            if(item.children&&item.text===this.automatedViewsConfig[id].menu){
              item.children.push(itemEntry);
              found=true;
              break;
            }
          }
          if(!found){
            allItems.push({
              icon: 'fa-angle-up',
              'icon-alt': 'fa-angle-down',
              text: this.automatedViewsConfig[id].menu,
              model: false,
              children: [itemEntry]
            });
          }
        } else if (!this.automatedViewsConfig[id].hidden) {
          allItems.push(itemEntry);
        }

      }
      let me=this
      if(this.userPlots){
        let filtered=this.userPlots.filter(x=>x.facility===me.$store.state.pointsListStore.pointsList.facility_name)
        if(filtered.length>0){
          allItems.push({
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'User',
            model: false,
            children: filtered.map(function(userPlot){
              return {'text':userPlot.title,'to':"/user-automated/"+userPlot.id}
            })
          });
        }

      }
      for (let item of allItems){
        if(item.facilityFilter&&item.facilityFilter!==""&&item.facilityFilter!==me.$store.state.pointsListStore.pointsList.facility_name){
          item.disabled=true
        } else if (item.facilityExceptFilter&&item.facilityExceptFilter===me.$store.state.pointsListStore.pointsList.facility_name){
          item.disabled=true
        }
        if(item.children){
          for (let child of item.children){
            if(child.facilityFilter&&child.facilityFilter!==""&&child.facilityFilter!==me.$store.state.pointsListStore.pointsList.facility_name){
              child.toRemove=1
            } else if(child.facilityExceptFilter&&child.facilityExceptFilter===me.$store.state.pointsListStore.pointsList.facility_name){
              child.toRemove=1
            }
          }
          item.children=item.children.filter(x=>!x.toRemove)
        }
      }
      return allItems;
    }

  },
  async mounted () {
    if(process.env.VUE_APP_PAGE_TITLE&&process.env.VUE_APP_PAGE_TITLE!=""){
      document.title=process.env.VUE_APP_PAGE_TITLE
    } else {
      document.title="Carnot Innovations Dashboard"
    }
    let token = localStorage.getItem('pass')
    if(token&&token!==""){
      let content=null;
      try {
        content = jwtDecode(token)
      }
      catch(err) {
          localStorage.setItem('pass', null)
        this.$router.push({
          name: 'login',
          params: {
            wantedRoute: this.$router.currentRoute.fullPath
          },
        });
        this.forceDisplay=true;
      }
      if(content){
        await this.$store.dispatch('setUser', {token: token, content: content})
        await this.$store.dispatch('refreshFacilityList')
        await this.$store.dispatch('refreshPointsList', null)
        if(!this.disableNotifications){
          await this.$store.dispatch('refreshNotification', this.$store.state.pointsListStore.pointsList.facility_name)
        }
      }
    } else if (process.env.VUE_APP_LOGIN!='yes') {
      await this.$store.dispatch('refreshFacilityList')
      await this.$store.dispatch('refreshPointsList', null)
      if(!this.disableNotifications) {
        await this.$store.dispatch('refreshNotification', this.$store.state.pointsListStore.pointsList.facility_name)
      }
    } else if(this.$router.currentRoute.name=="login"){
      this.forceDisplay=true;
    } else {
      this.$router.push({
        name: 'login',
        params: {
          wantedRoute: this.$router.currentRoute.fullPath
        },
      });
      this.forceDisplay=true;
    }
  }
}

</script>

<style scoped>
 .slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(30px);
  opacity: 0;
}
</style>

<style>
  .cursor-as-pointer{
    cursor: pointer;
  }
  .v-input__control>.v-input__slot input {
    caret-color: auto;
  }
  .v-card__title{
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
  .v-card__title .v-input{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .v-card__title button{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
</style>
